import {ABACPolicyEntity} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {BaseEntitySelect, BaseEntitySelectProps} from "../base-entity-select";

export type BaseABACPolicySelectProps = Omit<
  BaseEntitySelectProps<ABACPolicyEntity>,
  'nameMapper'
>

export const BaseABACPolicySelect = (props: BaseABACPolicySelectProps) => {
  const nameMapper = useCallback((e: ABACPolicyEntity) => {
    return e.name;
  }, []);

  return <BaseEntitySelect nameMapper={nameMapper} {...props} />;
};
